"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WORKING_OFFLINE = exports.ON_DIRECT_CALL = exports.ON_CALL = exports.ON_BREAK = exports.OFFLINE = exports.DO_NOT_DISTURB = exports.BUSY = exports.AWAY = exports.AVAILABLE = void 0;
var AVAILABLE = 'available';
exports.AVAILABLE = AVAILABLE;
var ON_DIRECT_CALL = 'onDirectCall';
exports.ON_DIRECT_CALL = ON_DIRECT_CALL;
var AWAY = 'away';
exports.AWAY = AWAY;
var BUSY = 'busy';
exports.BUSY = BUSY;
var DO_NOT_DISTURB = 'doNotDisturb';
exports.DO_NOT_DISTURB = DO_NOT_DISTURB;
var ON_BREAK = 'onBreak';
exports.ON_BREAK = ON_BREAK;
var ON_CALL = 'onCall';
exports.ON_CALL = ON_CALL;
var OFFLINE = 'offline';
exports.OFFLINE = OFFLINE;
var WORKING_OFFLINE = 'workingOffline';
exports.WORKING_OFFLINE = WORKING_OFFLINE;